export const SECTION_OFFSET_CHANGE = 'SECTION_OFFSET_CHANGE';
export const SECTION_SET_IN_VIEW = 'SECTION_SET_IN_VIEW';

export const NEW_PRODUCTS_GALLERY_CURRENT_CHANGE = 'NEW_PRODUCTS_GALLERY_CURRENT_CHANGE';

export const ALL_PRODUCTS_DIRECTORY_FILTER_CHANGE = 'ALL_PRODUCTS_DIRECTORY_FILTER_CHANGE';

export const PLACES_GALLERY_CURRENT_CHANGE = 'PLACES_GALLERY_CURRENT_CHANGE';



/** WEBPACK FOOTER **
 ** ./web/js/actions/types.js
 **/